export default __webpack_public_path__ + "static/media/gift.0a65989d.png";